import { render, staticRenderFns } from "./VideoIcon.vue?vue&type=template&id=03a2837e&scoped=true&"
import script from "./VideoIcon.vue?vue&type=script&lang=js&"
export * from "./VideoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a2837e",
  null
  
)

export default component.exports